export default __webpack_public_path__ + "static/media/pozostale-przyjecia.c5d77107.md";